import { PortfolioApp } from './PortfolioApp.js';
import { LoadingManager } from './utils/LoadingManager.js';
import { inject } from '@vercel/analytics';

class Main {
    constructor() {
        this.init();
    }

    async init() {
        try {
            const loadingManager = new LoadingManager();
            
            loadingManager.onProgress = (progress) => {
                const progressBar = document.getElementById('loading-progress');
                if (progressBar) {
                    progressBar.style.width = `${progress * 100}%`;
                }
            };

            loadingManager.onComplete = () => {
                const loadingScreen = document.getElementById('loading-screen');
                loadingScreen.classList.add('loaded');
                
                setTimeout(() => {
                    loadingScreen.style.display = 'none';
                }, 1000);
            };

            this.app = new PortfolioApp(loadingManager);
            window.portfolio = this.app;

            await this.app.init();

            this.setupDebugControls();

            // Initialize Vercel Analytics
            inject();
            
        } catch (error) {
            console.error('Failed to initialize portfolio:', error);
        }
    }

    setupDebugControls() {
        const debugToggle = document.getElementById('debug-toggle');
        const debugContent = document.querySelector('.debug-content');
        
        debugToggle?.addEventListener('click', () => {
            debugContent?.classList.toggle('show');
        });

        if (import.meta.env.DEV) {
            document.body.classList.add('debug-mode');
        } else {
            const debugPanel = document.getElementById('debug-panel');
            if (debugPanel) {
                debugPanel.style.display = 'none';
            }
        }
    }
}

new Main();